// extracted by mini-css-extract-plugin
module.exports = {"taker-assist":"taker-assist","page-wrapper_ta":"page-wrapper_ta"};